import styles from "./RadioButton.module.scss";

const RadioButton = ({ id, text, name, onChange, checked, value }) => {
  return (
    <label htmlFor={id} className={styles.label}>
      <input
        className={styles.input}
        type="radio"
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <span className={styles.customButton} />
      {text}
    </label>
  );
};

export default RadioButton;
